import $ from 'jQuery';
import Cookies from 'js-cookie';

import vars from '../../../../vars.js';

let technicalCookies = true;
let trackingCookies = true;
const googleAnalyticsID = vars.googleAnalyticsID;

const launchAnalytics = () => {
  const script1 = document.createElement('script');
  script1.type = 'text/javascript';
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsID}`;
  script1.async = '';

  const script2 = document.createElement('script');
  script2.type = 'text/javascript';
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', ${googleAnalyticsID});`;

  document.head.appendChild(script1);
  document.head.appendChild(script2);
};

const setHideBannerCookie = () => {
  Cookies.set('hide-banner', true);
};

function init() {

  // Init at true
  $('#toggle-all').prop('checked', true);
  $('#toggle-all').parent().addClass('checked');
  technicalCookies = true;
  $('#technical').prop('checked', true);
  $('#technical').parent().addClass('checked');
  trackingCookies = true;
  $('#tracking').prop('checked', true);
  $('#tracking').parent().addClass('checked');

  
  $('#toggle-all').on('click', (e) => {
    if(!e.target.checked) {
      technicalCookies = true;
      $('#technical').prop('checked', true);
      $('#technical').parent().addClass('checked');
      trackingCookies = true;
      $('#tracking').prop('checked', true);
      $('#tracking').parent().addClass('checked');
    }
    else {
      technicalCookies = false;
      $('#technical').prop('checked', false);
      $('#technical').parent().removeClass('checked');
      trackingCookies = false;
      $('#tracking').prop('checked', false);
      $('#tracking').parent().removeClass('checked');
    }
  });

  $('#technical').on('click', (e) => {
    technicalCookies = !e.target.checked;
  });

  $('#tracking').on('click', (e) => {
    trackingCookies = !e.target.checked;
  });
  
  $('#cookies-ok, #cookies-save').on('click', function(e) {
    e.preventDefault();
    $(this).parents('#cookiesbanner').fadeOut('fast');

    if (technicalCookies) {
      setHideBannerCookie();
    }

    if (trackingCookies && googleAnalyticsID) {
      launchAnalytics();
    }
    else if (technicalCookies) {
      Cookies.set('no-analytics', true);
    }
  });

  $('.expand-cookies').on('click', function() {
    $(this).toggleClass('active');
    $('.banner-cookies_expanded').toggleClass('visible');
  });

  if (! Cookies.get('hide-banner')) {
    setTimeout($('#cookiesbanner').css('display', 'block'), 1000);
  }
  else if (! Cookies.get('no-analytics')) {
    launchAnalytics();
  }
}

export default {
  init,
};


// WEBPACK FOOTER //
// ./src/static/js/modules/cookies.js